import React, { useState, useEffect } from 'react';
import { fetchHero } from '../services/strapi';

const Hero = () => {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getHero = async () => {
      try {
        setLoading(true);
        const data = await fetchHero();
        console.log(data);
        setHero(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getHero();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const baseUrl = process.env.REACT_APP_API_URL ;
  
  // Handle both image and video URLs
  const imageUrl = hero.HeroImage?.formats?.large?.url 
    ? `${baseUrl}${hero.HeroImage.formats.large.url}` 
    : "/path/to/default-image.jpg";
    
  const videoUrl = hero.HeroImage?.url 
    ? `${baseUrl}${hero.HeroImage.url}` 
    : null;

  const renderBackground = () => {
    console.log(videoUrl)
    if (videoUrl) {
      return (
        <video
          className="hero__video"
          autoPlay
          muted
          loop
          playsInline
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0
          }}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }
    return null;
  };

  return (
    <div>
      {hero && (
        <div 
          className='hero'
          style={{
            ...(videoUrl ? {} : {
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }),
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {renderBackground()}
          <div className="hero__overlay"></div>

          <div className='hero__content'>
            <div className='hero__title'>
              <h2>{hero.Title}</h2>
              <p>{hero.Description}</p>
            </div>
            <div className='hero__event-information'>
              <div>
                {new Date(hero.EventDate).toLocaleDateString('en-GB', {
                  weekday: 'short',
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric'
                })}, 
                {new Date(hero.EventDate).toLocaleTimeString('en-GB', {
                  hour: 'numeric',
                  minute: '2-digit',
                  hour12: true
                })}
              </div>
              <a href='#' title="bookEvent">BOOK</a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;